import React from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

const DashboardLayout = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const menuItems = [
    //{ title: 'Colorado Data', path: '/dashboard/colorado', description: 'Manage Colorado intake data' },
    //{ title: 'Reservoir Stats', path: '/dashboard/res-stats', description: 'View and update reservoir statistics' },
    //{ title: 'Flows', path: '/dashboard/flows', description: 'Flows information' },
    //{ title: 'Texana Data', path: '/dashboard/texana', description: 'Manage Texana intake data' },
    //{ title: 'Reservoir Weather', path: '/dashboard/reservoir-weather', description: 'Reservoir Weather' },
    //{ title: 'Choke Canyon', path: '/dashboard/choke-canyon', description: 'Choke Canyon Reservoir data', icon: 'water' },
    //{ title: 'Wesley Seale Dam', path: '/dashboard/wesley-seale-dam', description: 'Wesley Seale Dam data', icon: 'dashboard' },
    //{ title: 'Wesley Seale Gates', path: '/dashboard/wesley-seale-gates', description: 'Wesley Seale Dam B.V. and Sluice Gates', icon: 'settings' },
    { title: 'Daily Flows', path: '/dashboard/daily-flows', description: 'Manage Texana and Colorado flow rates', icon: 'timeline' },
    //{ title: 'Report', path: '/Report', description: 'Report' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('session');
    localStorage.removeItem('username');
    localStorage.removeItem('userGroups');
    
    if (onLogout) {
      onLogout();
    }
    
    navigate('/login', { replace: true });
  };

  const isDashboardRoot = location.pathname === '/dashboard';

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Google-style header */}
      <header className="bg-white border-bottom shadow-sm py-2">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <button 
              className="btn p-0 me-4" 
              onClick={() => navigate('/dashboard')}
            >
              <span className="material-icons-outlined fs-3 text-primary">dashboard</span>
            </button>
            
            <div className="d-flex">
              {menuItems.map((item) => (
                <button
                  key={item.path}
                  className={`btn rounded-pill px-3 py-2 me-2 ${
                    location.pathname === item.path ? 'bg-light fw-bold' : 'text-secondary'
                  }`}
                  onClick={() => navigate(item.path)}
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
          
          <button 
            className="btn btn-outline-secondary rounded-pill px-3"
            onClick={handleLogout}
          >
            <span className="small">Logout</span>
          </button>
        </div>
      </header>

      {/* Main content */}
      <div className="container flex-grow-1 py-4">
        {isDashboardRoot ? (
          <div className="row g-4 mt-2">
            {menuItems.map((item) => (
              <div className="col-md-4" key={item.path}>
                <div 
                  className="card border-0 rounded-4 shadow-sm h-100 transition-all"
                  onClick={() => navigate(item.path)}
                  style={{ 
                    cursor: 'pointer', 
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '';
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                      <span className="material-icons-outlined p-2 rounded-circle text-primary bg-light me-3">
                        {item.icon}
                      </span>
                      <h5 className="card-title m-0">{item.title}</h5>
                    </div>
                    <p className="card-text text-secondary mb-0">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white p-4 rounded-4 shadow-sm">
            <Outlet />
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardLayout;